<template>
    <div class="horse-preview-pedigree flex flex-column gap-5">
        <div class="flex justify-content-between">
            <div class="header">{{ $t('message.horsePreview.pedigree.header') }}</div>
            <CustomTextButton v-if="depthLasts <5" :label="$t('message.horsePreview.pedigree.seeGenerations')"
                              @click="morePedigreeDialog = true"/>
            <Dialog v-model:visible="morePedigreeDialog" :header="$t('message.horsePreview.pedigree.header')"
                    modal :closable="true" style="height: 1600px; width: 1500px;">
                <PedigreeHorse :modelValue="selectedHorse" :depthLasts="dialogDepthLasts" first class="p-3"/>
            </Dialog>
        </div>
        <div class="horse-pedigree-graph">
            <PedigreeHorse :modelValue="selectedHorse" :depthLasts="depthLasts" first/>
        </div>
    </div>
</template>

<script>
import Dialog from "primevue/dialog";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import PedigreeHorse from "@/views/horse/horseList/components/PedigreeHorse.vue";
import OwnerForm from "@/views/owner/components/OwnerForm.vue";

export default {
    name: "HorsePreviewPedigree",
    components: {
        OwnerForm,
        PedigreeHorse,
        CustomTextButton,
        Dialog,
    },

    props: {
        selectedHorse: {
            type: Object,
            required: true,
        },
        depthLasts: {
            type: Number,
            default: 2,
        },
        dialogDepthLasts: {
            type: Number,
            default: 5,
        },
    },

    data() {
        return {
            morePedigreeDialog: false,
        };
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.horse-preview-pedigree {
    background-color: var(--secondary-color);
    padding: 2rem;
    border-radius: 7px;

    .header {
        font-size: 21px;
        text-transform: uppercase;
        font-weight: 600;
    }
}
.horse-preview {
    .horse-preview-pedigree {
        .horse-pedigree-graph {
            padding-bottom: 2rem;
            overflow-x: auto;
        }
    }
}
</style>
